import { type PaymentDueTermsAll } from '~components/business-owner/customers/invoices/constants';

import { ObjectValues } from '~types/typeUtils';

export const INVOICE_PAYMENT_STATUS = {
	PAID: 'PAID',
	UNPAID: 'UNPAID',
	PENDING: 'PENDING',
	PARTIALLY_PAID: 'PARTIALLY_PAID',
} as const;

export const enum InvoiceVirtualPaymentStatuses {
	DUE_SOON = 'DueSoon',
	OVERDUE = 'Overdue',
}

export type INVOICE_PAYMENT_STATUS_TYPE = ObjectValues<typeof INVOICE_PAYMENT_STATUS>;

export const INVOICE_PAID_PAYMENT_STATUSES: INVOICE_PAYMENT_STATUS_TYPE[] = [
	INVOICE_PAYMENT_STATUS.PAID,
	INVOICE_PAYMENT_STATUS.PARTIALLY_PAID,
];

export const INVOICE_TO_PAY_PAYMENT_STATUSES: INVOICE_PAYMENT_STATUS_TYPE[] = [
	INVOICE_PAYMENT_STATUS.UNPAID,
	INVOICE_PAYMENT_STATUS.PARTIALLY_PAID,
];

export const INVOICE_STATUS = {
	CREATED: 'CREATED',
	PAID: 'PAID',
	SENT: 'SENT',
	OPENED: 'OPENED',
	PENDING: 'PENDING',
} as const;
export type INVOICE_STATUS_TYPE = ObjectValues<typeof INVOICE_STATUS>;

export enum InvoicePeriods {
	CUSTOM = 'CUSTOM',
	MONTHLY = 'MONTHLY',
	WEEKLY = 'WEEKLY',
}

export const INVOICE_PAYMENT_METHOD = {
	CHECK: 'CHECK',
	CASH: 'CASH',
	ACH: 'ACH',
	CREDIT_CARD: 'CREDIT_CARD',
	CARD: 'CARD',
} as const;
export type INVOICE_PAYMENT_METHOD_TYPE = ObjectValues<typeof INVOICE_PAYMENT_METHOD>;

export const INVOICE_PAYMENT_TYPE = {
	ONLINE: 'ONLINE',
	OFFLINE: 'OFFLINE',
} as const;
export type INVOICE_PAYMENT_TYPE_VALUE = ObjectValues<typeof INVOICE_PAYMENT_TYPE>;

/**
 * @deprecated - Use `PaymentDueTermsAll` instead
 */
export type INVOICE_PAYMENT_DUE_TERM_VALUE = PaymentDueTermsAll;

export const INVOICE_PAYMENT_DATE_FORMAT = 'M/D/YY';

export enum InvoicePaymentTransactionProviders {
	STRIPE = 'stripe',
	CASH = 'cash',
	CHECK = 'check',
}

export enum InvoicePaymentSourceApps {
	BUSINESS_MANAGER = 'BUSINESS_MANAGER',
	COMMERCIAL_CLIENT = 'COMMERCIAL_CLIENT_INVOICE_VIEW',
}

export const INVOICE_CODE_PREFIX = 'INV';
